'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ../~/intl-format-cache/index.js
// module id = 473
// module chunks = 0